export const setHeight = () => {
  const elems = document.getElementsByClassName("fullHeightContainerBox");
  for (let elem of elems) {
    (elem as HTMLElement).style.height = window.innerHeight + "px";
  }
};
